// extracted by mini-css-extract-plugin
module.exports = {"list":"list--3RmpP","before":"before--9dJyX","item":"item--2Wdkd","title":"title--15qil","after":"after--1-x6c"};